let inactivityTimer;
let sessionExpired = false; // Prevent multiple popups after timeout

export const startSessionTimeout = (timeoutDuration, onTimeout) => {
  // Prevent restarting timeout if session already expired
  if (sessionExpired) return () => {};

  // Clear any existing timer
  if (inactivityTimer) clearTimeout(inactivityTimer);

  // Set a new inactivity timer
  inactivityTimer = setTimeout(() => {
    if (!sessionExpired) {
      sessionExpired = true; // Mark session as expired to prevent further popups
      onTimeout();
    }
  }, timeoutDuration);

  // Reset timer on user activity
  const resetTimer = () => {
    if (sessionExpired) return; // Do not restart session if already expired

    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
      if (!sessionExpired) {
        sessionExpired = true;
        onTimeout();
      }
    }, timeoutDuration);
  };

  // Add global event listeners for user activity
  window.addEventListener("mousemove", resetTimer);
  window.addEventListener("keydown", resetTimer);
  window.addEventListener("scroll", resetTimer);

  // Return a cleanup function to remove event listeners
  return () => {
    clearTimeout(inactivityTimer);
    window.removeEventListener("mousemove", resetTimer);
    window.removeEventListener("keydown", resetTimer);
    window.removeEventListener("scroll", resetTimer);
  };
};

// Function to manually stop the timeout after session ends
export const stopSessionTimeout = () => {
  clearTimeout(inactivityTimer);
  sessionExpired = true; // Prevents further execution
};
